import { useContextValue } from '../../../context/context';
import { LocationIcon } from "../../../assets/cardIcons";
import ClosePopUpButton from "../../ClosePopUpButton/ClosePopUpButton";
import './style.css';
//? Temporary data
const distancesData = ["1km - 5 km", "5 km - 30 km", "30 km - 100 km"];

const DistancePopUp = ({ onClose }) => {
	const { setDistance, filledCards, setFilledCards } = useContextValue();

	const handleDistance = (distance) => {
		setDistance(distance);

		const newCard = { content: distance, isSelected: true, title: "Entfernung", backgroundColor: "#D66641", icon: LocationIcon };
		const existingCardIndex = filledCards.findIndex(card => card.title === newCard.title);

		if (existingCardIndex !== -1) {
			// Якщо картка існує, створюємо новий масив з оновленою карткою
			const updatedCards = [...filledCards];
			updatedCards[existingCardIndex] = newCard;
			setFilledCards(updatedCards);
		} else {
			// Якщо картки немає, додаємо нову
			setFilledCards([...filledCards, newCard]);
		}

		onClose();
	}

	return (
		<div className="distance-popup">
			<div className="distance-options">
				{
					distancesData.map((distance, index) => <p key={index} onClick={() => handleDistance(distance)} className="distance-option">{distance}</p>)
				}
				<button className="distance-pop-up-allGermany" onClick={() => handleDistance("Ganz Deutschland")}>Ganz Deutschland</button>
			</div>
			<ClosePopUpButton onClose={onClose} />
		</div>
	)
}

export default DistancePopUp;